import { useEffect, useState } from 'react';
import AdBannerApi from '../api/AdBannerApi';
import { resolveImageUrl } from './ImageService';

export const mapApiBanner = (banner) => ({
    src: resolveImageUrl(banner.imageUrl),
    to: banner.linkUrl || '',
    target: banner.linkTarget === '_blank' ? '_blank' : undefined,
});

export const mapApiGroups = (groups = []) =>
    groups.map((group) => group.map(mapApiBanner));

export const mapApiItems = (items = []) => items.map(mapApiBanner);

/** Banner.js 등 `link` 필드를 쓰는 컴포넌트용 */
export const mapApiBannerLink = (banner) => ({
    src: resolveImageUrl(banner.imageUrl),
    link: banner.linkUrl || '',
});

export const mapApiItemsLink = (items = []) => items.map(mapApiBannerLink);

/** API `{src, to}` → `{src, link}` */
export const toLinkItems = (items = []) =>
    items.map(({ src, to, link }) => ({ src, link: link || to || '' }));

/**
 * @param {string} slot
 * @param {{ items?: array, groups?: array[][] }} fallback
 */
export function useAdBanners(slot, fallback = null) {
    const [items, setItems] = useState(fallback?.items || null);
    const [groups, setGroups] = useState(fallback?.groups || null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;

        AdBannerApi.getBanners(slot)
            .then((res) => {
                if (cancelled || !res || res.code !== 'success') return;

                if (Array.isArray(res.groups) && res.groups.length > 0) {
                    setGroups(mapApiGroups(res.groups));
                    setItems(null);
                } else if (Array.isArray(res.items)) {
                    setItems(res.items.length > 0 ? mapApiItems(res.items) : []);
                    setGroups(null);
                }
            })
            .finally(() => {
                if (!cancelled) setLoaded(true);
            });

        return () => {
            cancelled = true;
        };
    }, [slot]);

    return { items, groups, loaded };
}
